import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { environment } from '../../environments/environment';

@Injectable()
export class DevRouteGuardService implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    if (environment.devRoutes) {
      return true;
    } else {
      this.router.navigate([''], { replaceUrl: true });
      return false;
    }
  }
}
